import { render, staticRenderFns } from "./policy_pa.vue?vue&type=template&id=6e429554"
import script from "./policy_pa.vue?vue&type=script&lang=js"
export * from "./policy_pa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports